module.exports = __webpack_public_path__ + "static/media/2.74b5191e.png";